import { Link } from 'react-router-dom';

export default function ServicesHero() {
  const stats = [
    { value: '9+', label: 'Program Types' },
    { value: '5+', label: 'Years of Excellence' },
    { value: '100+', label: 'Students Developed' },
    { value: 'All Ages', label: 'Welcome Here' },
  ];

  return (
    <section className="relative min-h-[72vh] flex items-end overflow-hidden">
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-[#0F172A] via-[#1E3A8A] to-[#3B0764]" />
      <div className="absolute inset-0 z-0 pointer-events-none select-none">
        <img
          src="https://static.readdy.ai/image/b0ab6c1eb002a8cf89683099ba8ee0be/a9a19e6966780984f72576a4f2fc1316.png"
          alt=""
          className="absolute top-[-40px] right-[-20px] w-[580px] h-auto object-contain opacity-[0.15] mix-blend-screen"
        />
      </div>
      <div className="absolute inset-0 z-0 bg-gradient-to-t from-[#0F172A]/90 via-transparent to-[#0F172A]/30" />

      <div className="absolute top-24 left-16 w-72 h-72 bg-brand-yellow/8 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-32 right-20 w-80 h-80 bg-brand-purple-light/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-8 pb-20 pt-40">
        <div className="flex flex-col lg:flex-row gap-16 items-end">
          <div className="flex-1">
            <span
              className="hero-badge inline-block px-4 py-1.5 rounded-full border border-brand-yellow/50 text-brand-yellow font-body text-xs uppercase tracking-widest bg-brand-yellow/10 mb-6"
              style={{ animation: 'wordFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) both', animationDelay: '0.1s' }}
            >
              Everything We Offer
            </span>
            <h1 className="font-heading text-white text-6xl lg:text-8xl font-black leading-tight mb-6">
              <span
                className="block"
                style={{ animation: 'wordFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) both', animationDelay: '0.3s' }}
              >
                One Place.
              </span>
              <span
                className="block text-brand-yellow"
                style={{ animation: 'wordFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) both', animationDelay: '0.55s' }}
              >
                Every Gift.
              </span>
            </h1>
            <p
              className="font-body text-white/70 text-lg max-w-xl leading-relaxed mb-10"
              style={{ animation: 'wordFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) both', animationDelay: '0.8s' }}
            >
              From beginner lessons and in-home instruction to professional studio sessions and large-scale event production, Creative Institute covers every dimension of the creative experience.
            </p>
            <div
              className="flex flex-wrap gap-4"
              style={{ animation: 'wordFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) both', animationDelay: '1.05s' }}
            >
              <Link
                to="/contact"
                className="whitespace-nowrap px-8 py-4 rounded-full bg-brand-yellow text-brand-blue-dark font-body font-bold text-sm hover:bg-brand-yellow-light transition-all cursor-pointer"
              >
                Get Started
              </Link>
              <Link
                to="/pricing-support"
                className="whitespace-nowrap px-8 py-4 rounded-full border-2 border-white/40 text-white font-body font-semibold text-sm hover:border-brand-yellow hover:text-brand-yellow transition-all cursor-pointer"
              >
                View Pricing
              </Link>
            </div>
          </div>

          <div
            className="flex-shrink-0 w-full lg:w-auto"
            style={{ animation: 'wordFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) both', animationDelay: '1.25s' }}
          >
            <div className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="p-5 rounded-2xl bg-white/8 border border-white/12 text-center backdrop-blur-sm">
                  <p className="font-heading text-3xl font-black text-brand-yellow mb-1">{s.value}</p>
                  <p className="font-body text-white/55 text-xs uppercase tracking-wider">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Keyframes ── */}
      <style>{`
        @keyframes wordFadeUp {
          0%   { opacity: 0; transform: translateY(14px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
